<script setup lang="ts">
import {useApiErrorNotifications} from "@/composables/useApiErrorNotifications"

const apiErrorNotifications = useApiErrorNotifications()
const { copy } = useClipboard()
const { t } = useI18n()
const notifications = apiErrorNotifications.apiErrors
const { setSuccessMsg } = useSnackbarStore()

const copyTraceId = (traceId: string) => {
  copy(traceId)
  setSuccessMsg(t("common.traceIdCopied", { traceId }))
}
const clearNotifications = () => {
  apiErrorNotifications.clearApiErrors()
  showErrors.value = false
}

const hasItems = computed(() => notifications.value.length > 0)

const timeAgo = (ts: number) => {
  return useTimeAgo(ts).value
}

const showErrors = ref(false)
</script>

<template>
  <UPopover v-if="notifications.length > 0" :open-delay="60" :close-delay="100" mode="hover">
    <!-- trigger -->
    <UChip inset color="error" :ui="{
      base: 'absolute -top-2 -right-1 min-w-[20px] h-[22px] px-1 rounded-full bg-error text-white text-[10px] leading-[18px] text-center font-bold',
    }">
      <UButton icon="i-mdi-error-outline" variant="ghost">
      </UButton>

      <template #content>
        <div> {{notifications.length}}</div>
      </template>
    </UChip>

    <!-- content -->
    <template #content>
      <div class="w-80 max-h-96 overflow-auto rounded-md shadow-lg p-2">
        <div class="flex items-center justify-between px-2 py-1">
          <UButton size="sm" variant="ghost" color="error" :disabled="!hasItems" @click="clearNotifications()">
            {{ t('notifications.clearAll') }}
          </UButton>
        </div>

        <div class="border-t border-default my-1" />

        <TransitionGroup name="slide-y" tag="div">
          <div v-for="n in notifications" :key="n.id"
            class="rounded-md px-3 py-2 hover:bg-elevated/50 transition-colors">
            <div class="flex items-start justify-between gap-2">
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium truncate">{{ n.errorCode }}</p>
                <p class="text-xs opacity-80 truncate">
                  <span v-if="n.traceId">{{ n.traceId }}</span>
                  <span class="opacity-60"> • {{ timeAgo(n.timestamp ?? 0) }}</span>
                </p>
                <p class="text-xs mt-1">{{ n.message }}</p>
              </div>
              <div class="flex items-center gap-1 shrink-0">
                <UButton variant="ghost" size="xs" icon="i-mdi-content-copy"
                  @click.stop="copyTraceId(n.traceId ?? '')" />
                <UButton variant="ghost" size="xs" icon="i-mdi-delete-outline" color="error"
                  @click.stop="apiErrorNotifications.remove(n.id ?? '')" />
              </div>
            </div>
          </div>
        </TransitionGroup>
      </div>
    </template>
  </UPopover>
</template>
